import instanciaAxios from './InterceptorAxios';


const servicioDescargaArchivos = {
    descargaArchivo(url, datos) {
        let request = {
            method: 'post',
            url: url,
            data: datos,
            responseType: 'arraybuffer'
        }
        instanciaAxios(request).then((response) => {
            let headers = response.headers;
            let encabezadoContent = headers['content-disposition'];
            let result = encabezadoContent.split(';')[1].trim().split('=')[1];
            let fileName = result.replace(/"/g, '');
            let a = document.createElement("a");
            let contentType = headers['content-type'];            
            let tipo = this.elegirTipo(contentType);            
            document.body.appendChild(a);
            let file = new Blob([response.data], {
                type: tipo
            });
            let fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }).catch((error) => {
            console.log(error);
        });
    },

    imprimirFlujoBytesArchivo(response){
        let headers = response.headers;
        let encabezadoContent = headers['content-disposition'];
        let result = encabezadoContent.split(';')[1].trim().split('=')[1];
        let fileName = result.replace(/"/g, '');
        let a = document.createElement("a");
        let contentType = headers['content-type'];   
        console.log(contentType);         
        let tipo = this.elegirTipo(contentType);            
        document.body.appendChild(a);
        let file = new Blob([response.data], {
            type: tipo
        });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = fileName;
        a.click();
    },

    elegirTipo(contentType) {
        let respuesta = "";        
        switch (contentType) {
            case 'application/vnd.ms-excel':
                respuesta = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            break;

            case 'application/pdf':
                respuesta=contentType;
            break;

            case 'application/xml':
                respuesta=contentType;
            break;

            case 'application/zip':
                respuesta=contentType;
            break;

            default:
                respuesta = "";
        }
        return respuesta;
    }


}

export default servicioDescargaArchivos;